const PAGE_SELECTORS = {
  1: ".splide__slide.is-active",
  2: ".splide__slide.is-next",
};

export function getDownload(page, track, info) {
  if (page === "all") {
    if (!info.filePath || !info.filename) {
      throw new TypeError("The complete PDF download is not available.");
    }
    return { path: info.filePath, name: info.filename };
  }

  const selector = PAGE_SELECTORS[page];
  const filename = selector
    ? track.querySelector(selector)?.dataset.downloadPage
    : undefined;

  if (!filename) {
    throw new TypeError(
      `The requested page ${page} is not available for download.`,
    );
  }

  return {
    path: `${info.path}pagePDFs/${filename}`,
    name: `${info.name}__${filename}`,
  };
}
